import { render, staticRenderFns } from "./LabResultsModal.vue?vue&type=template&id=f6fc254e&scoped=true&"
import script from "./LabResultsModal.vue?vue&type=script&lang=js&"
export * from "./LabResultsModal.vue?vue&type=script&lang=js&"
import style0 from "./LabResultsModal.vue?vue&type=style&index=0&id=f6fc254e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6fc254e",
  null
  
)

export default component.exports